import { AnonymousAuthenticationProvider } from "@microsoft/kiota-abstractions";
import { DefaultRequestAdapter } from "@microsoft/kiota-bundle";
import { createOrderApiClient } from "./generated/orderApiClient";

// Create the API client
export const createClient = (apiBaseUrl: string) => {
  // API requires no authentication, so use the anonymous
  // authentication provider
  const authProvider = new AnonymousAuthenticationProvider();

  // Create request adapter using the fetch-based implementation
  const adapter = new DefaultRequestAdapter(authProvider);

  adapter.baseUrl = `${apiBaseUrl}/order`;

  return createOrderApiClient(adapter);
};
